import { createFileRoute } from "@tanstack/react-router";
import { TeacherDashboard } from "@/projects/teacher/pages/DashboardPage";

export const Route = createFileRoute("/teacher/")({
  head: () => ({
    meta: [{ title: "Teacher Dashboard — રાજનગર જ્ઞાનોત્સવ 2.0" }],
  }),
  component: TeacherDashboard,
});
